import { render, staticRenderFns } from "./cart-item.vue?vue&type=template&id=4940fedd&"
import script from "./cart-item.vue?vue&type=script&lang=js&"
export * from "./cart-item.vue?vue&type=script&lang=js&"
import style0 from "./cart-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4940fedd')) {
      api.createRecord('4940fedd', component.options)
    } else {
      api.reload('4940fedd', component.options)
    }
    module.hot.accept("./cart-item.vue?vue&type=template&id=4940fedd&", function () {
      api.rerender('4940fedd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/header/cart-item.vue"
export default component.exports